import axios from 'axios';
import { useEffect, useState } from 'react';

import { webSocketApiUrlsDictionary } from '../constants';
interface Phone {
  country: string;
  area: string;
  number: string;
  type: string;
}

interface Customer {
  name: string;
  email: string;
  phones: Phone[];
}

interface Card {
  number: string;
  expMonth: string;
  expYear: string;
  holder: {
    name: string;
  };
}

interface PaymentMethod {
  type: 'DEBIT_CARD' | 'CREDIT_CARD';
  installments: number;
  card: Card;
}

interface Amount {
  value: number;
  currency: string;
}

interface Address {
  street: string;
  number: number;
  complement: string;
  regionCode: string;
  country: string;
  city: string;
  postalCode: string;
}

interface PaymentData {
  customer: Customer;
  paymentMethod: PaymentMethod;
  amount: Amount;
  billingAddress: Address;
  shippingAddress: Address;
  dataOnly: boolean;
}

export interface PaymentRequest {
  request: {
    data: PaymentData;
  };
  session: string;
}

const token = localStorage.getItem('auth-token');
const theme = localStorage.getItem('theme');

const defaultUrl =
  webSocketApiUrlsDictionary[theme]?.gatewayUrl ||
  process.env.REACT_APP_API_GATEWAY_URL;

const apiPB = axios.create({
  baseURL: `${defaultUrl}/mk-ms-payment-pagbank`,
  headers: {
    Platform: 'DASHBOARD',
    ...(token && { Authorization: `Bearer ${token}` }),
  },
});

export const getUserPrimaryCard = async (userUuid: string) => {
  try {
    const response = await apiPB.get(`/cards/users/${userUuid}/primary`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response;
    } else {
      throw error;
    }
  }
};

// MV2-2053: o /primary devolve 404 quando o usuário não tem nenhum cartão (a exclusão é física).
// null = não foi possível saber (erro/rede), para a tela não afirmar "Sem cartão" sem certeza.
export const hasPagBankCard = async (
  userUuid?: string | null,
): Promise<boolean | null> => {
  if (!userUuid) {
    return false;
  }

  try {
    await getUserPrimaryCard(userUuid);
    return true;
  } catch (error: any) {
    return error?.status === 404 ? false : null;
  }
};

export function usePagSeguro() {
  const [pagseguro, setPagseguro] = useState(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      'https://assets.pagseguro.com.br/checkout-sdk-js/rc/dist/browser/pagseguro.min.js';
    script.async = true;
    script.onload = () => {
      const { PagSeguro } = window as any;

      setPagseguro(PagSeguro);
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return pagseguro;
}

export const authenticate3DS = async (pagseguro: any, data: PaymentRequest) => {
  try {
    pagseguro.setUp({
      session: data.session,
      env: 'PROD',
    });

    const response = await pagseguro.authenticate3DS(data.request);

    (window as any)?.ReactNativeWebView.postMessage(JSON.stringify(response));

    return response;
  } catch (e) {
    (window as any)?.window.ReactNativeWebView?.postMessage(
      JSON.stringify({ type: 'error' }),
    );
  }
};
